import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  animate?: boolean;
}

const BackwardIcon: React.FC<Props> = (props) => {
  const { animate, ...svgProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...svgProps}
      aria-label="backward icon"
    >
      {/* <title>backward icon</title> */}
      <path
        d="M17.6537 16.2414L11.6237 11.217V8.28462L17.6537 3.26053C18.3791 2.65823 19.5 3.16384 19.5 4.12618V15.374C19.5 16.3364 18.3791 16.8427 17.6537 16.2414ZM8.65297 16.2414L1.90215 10.6474C1.36595 10.1949 1.36595 9.36862 1.90215 8.9161L8.65297 3.32206C9.37833 2.72011 10.4993 3.2254 10.4993 4.18771V15.4356C10.4989 16.3364 9.37728 16.8427 8.65297 16.2414Z"
        fill={
          animate
            ? "url(#linearGradient)"
            : props.fill || "currentColor" || "white"
        }
      />
      {animate && (
        <defs>
          <linearGradient id="linearGradient">
            <stop offset="0%" stopColor="transparent">
              <animate
                attributeName="stop-color"
                values="transparent;#fff;transparent"
                dur="750ms"
                repeatCount="indefinite"
              />
            </stop>
            <stop offset="100%" stopColor="#fff">
              <animate
                attributeName="stop-color"
                values="#fff;transparent"
                dur="750ms"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>
        </defs>
      )}
    </svg>
  );
};

export default BackwardIcon;
